import { Col, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import Filter from "../../../components/reports/alert/Filter";
import List from "../../../components/reports/alert/List";
import { AuthContext } from "../../../context/auth";
import api from "../../../services/api";
import { Translate } from "../../../translate";
import { findPath } from "../../../util/location";
import { messageError } from "../../../util/messages";
import { datetimeSort, toDateLocalNow, toDateLocalToday } from "../../../util/time";

const Alert = () => {
  const { environment } = useContext(AuthContext);
  const [categories, setCategories] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState([]);
  const [range, setRange] = useState([
    toDateLocalToday(),
    toDateLocalNow(),
  ]);

  const fetchCategories = () => {
    api
      .get("/maintenance/category/tree/")
      .then((response) => {
        let _categories = response.data.sort((a, b) =>
          a.label.localeCompare(b.label)
        );
        setCategories(_categories);
      })
      .catch((error) => messageError(error));
  };

  const fetchLocations = () => {
    api
      .get("/maintenance/location/tree/", { params: { disabled: true } })
      .then((response) => {
        setLocations(response.data);
      })
      .catch((error) => messageError(error));
  };

  const search = async (values) => {
    try {
      setLoading(true);
      let { data } = await api.get("/survey/survey/group/local/cat", {
        params: values,
      });
      let _range = datetimeSort(range[0]) + "-" + datetimeSort(range[1]);
      if (data && data.length > 0) {
        data.forEach((element) => {
          element.range = _range;
          let location = findPath(locations, element.id);
          if (location) element.location = location;
        });
      }
      setData(data);
    } catch (error) {
      messageError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLocations();
    fetchCategories();
  }, [environment]);

  return (
    <>
      <Row>
        <Col xs={24}>
          <span className="text-title primary-text-color">
            {" "}
            {Translate.t("menu.alert")}
          </span>
        </Col>
        <Col xs={24} style={{ marginTop: "10px" }}>
          <span className="text-sub secondary-text-color">
            {" "}
            {Translate.t("title.info.alert")}
          </span>
        </Col>
      </Row>
      <Filter
        search={search}
        loading={loading}
        locations={locations}
        range={range}
        setRange={setRange}
        data={data}
        categories={categories}
      />
      <List data={data} loading={loading} categories={categories} />
    </>
  );
};

export default Alert;
